import React from "react";
import Hero from "components/hero/Hero";
import Footer from "components/footers/FiveColumnDark";
import SplashAnimationContainer from "helpers/SplashAnimationContainer";
import GlobalStyle from "helpers/GlobalStyle";
import useScreenSize from "helpers/useScreenSize";
import SalaryPageContent from "components/Salary/SalaryPageContent";

export default () => {
  const { isXs } = useScreenSize();

  return (
    <div style={{ marginTop: "50px" }}>
      <GlobalStyle />
      <Hero isXs={isXs} />
      <SplashAnimationContainer>
        <SalaryPageContent />
        <Footer isXs={isXs} />
      </SplashAnimationContainer>
    </div>
  );
};
